import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { PROCESS_STEPS, IMAGES } from "@/data/content";

export default function Process() {
  return (
    <div data-testid="page-process">
      <PageHero
        overline="— Process"
        title="Ten stages."
        accent="Every project."
        body="Structured workflows for both visualization and technical production projects — designed to surface decisions early and reduce surprises late."
        image={IMAGES.portfolio2}
        testid="process-hero"
      />

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24" data-testid="process-steps">
        <div className="grid md:grid-cols-12 gap-x-12">
          {PROCESS_STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 40} className="md:col-span-6">
              <div className="py-8 border-b border-white/5 flex gap-6">
                <span className="num text-5xl text-[#B58B5D] shrink-0">{s.n}</span>
                <div>
                  <h3 className="font-serif text-2xl text-[#EAEAEA] mb-2">{s.title}</h3>
                  <p className="text-[15px] text-[#A3A3A3] leading-relaxed">{s.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-[#0E0E0E] border-y border-white/5 py-24" data-testid="process-cv">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <Reveal>
            <div className="overline mb-3">— Cabinet Vision implementation</div>
            <h2 className="font-serif text-4xl md:text-5xl max-w-3xl mb-12">A controlled deployment, not a switch flipped overnight.</h2>
          </Reveal>
          <ul className="grid md:grid-cols-3 gap-x-8">
            {[
              "Workflow audit",
              "Construction & product standard review",
              "Library and naming architecture",
              "UCS, material, hardware and report requirements",
              "Test cabinet and representative job development",
              "Production and CNC validation",
              "Controlled deployment",
              "Role-specific user training",
              "Documentation and revision management",
            ].map((s, i) => (
              <Reveal key={s} delay={i * 50}>
                <li className="py-5 border-b border-white/5 flex gap-4 text-[15px]">
                  <span className="num text-[#B58B5D]">{String(i + 1).padStart(2, "0")}</span>
                  <span className="text-[#EAEAEA]">{s}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
